module.exports = __webpack_public_path__ + "img/bgc.a3cec3fb.svg";